import { PureComponent } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import UIButton from 'UIComponents/button/UIButton';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIModal from 'UIComponents/dialog/UIModal';
import UIIllustration from 'UIComponents/image/UIIllustration';
import OpenFacebookRow from './OpenFacebookRow';
import GoToInboxRow from './GoToInboxRow';
import H2 from 'UIComponents/elements/headings/H2';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
class VerifyFbmPrompt extends PureComponent {
  componentDidMount() {
    const {
      pageId,
      getFbmInstall
    } = this.props;
    getFbmInstall({
      pageId
    });
  }
  render() {
    const {
      closePrompt,
      pageName,
      pageLink
    } = this.props;
    if (!pageName) {
      return null;
    }
    return /*#__PURE__*/_jsxs(UIModal, {
      use: "conversational",
      width: 670,
      className: "verify-fbm-prompt selenium-test-marker-verify-fbm-prompt",
      children: [/*#__PURE__*/_jsx(UIDialogHeader, {
        children: /*#__PURE__*/_jsx(H2, {
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "MessagesApp.verifyFbmPrompt.header",
            options: {
              pageName
            }
          })
        })
      }), /*#__PURE__*/_jsxs(UIDialogBody, {
        children: [/*#__PURE__*/_jsx("div", {
          className: "m-bottom-5",
          children: /*#__PURE__*/_jsx(UIIllustration, {
            name: "successfully-submitted-question",
            width: 120
          })
        }), /*#__PURE__*/_jsx("p", {
          className: "m-bottom-8",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "MessagesApp.verifyFbmPrompt.subheader"
          })
        }), /*#__PURE__*/_jsxs("div", {
          className: "text-left m-bottom-3",
          children: [/*#__PURE__*/_jsx(UIIllustration, {
            name: "beta",
            width: 40
          }), /*#__PURE__*/_jsx("h5", {
            className: "display-inline-block m-left-3",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "MessagesApp.verifyFbmPrompt.tableHeader"
            })
          })]
        }), /*#__PURE__*/_jsxs("div", {
          children: [/*#__PURE__*/_jsx(OpenFacebookRow, {
            pageLink: pageLink
          }), /*#__PURE__*/_jsx(GoToInboxRow, {
            onConfirm: closePrompt
          })]
        }), /*#__PURE__*/_jsx("div", {
          className: "m-top-7",
          children: /*#__PURE__*/_jsx(UIButton, {
            onClick: closePrompt,
            use: "primary",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "MessagesApp.verifyFbmPrompt.closeButton"
            })
          })
        })]
      })]
    });
  }
}
VerifyFbmPrompt.displayName = 'VerifyFbmPrompt';
export default VerifyFbmPrompt;